.cardBodyContainer {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
  padding-top: var(--spacingLg);
}

.cardBody {
  /* left padding equals action icon size + it's padding + gap between left side header elements  */
  padding: var(--spacingLg) 0 var(--spacingLg) calc(1.25rem + var(--spacingMd) * 2 + var(--spacingMd));
  display: flex;
  gap: var(--spacingLg);
}

.sideArea {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacingLg);
  width: 170px; // to make it align with header line
}

.mainArea {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: var(--spacingLg);
}
